export default {
    title: 'Escolha uma Opção',

    home: {
        title: 'Início',
        desc: 'Página inicial'
    },
    explore: {
        title: 'Explorar',
        desc: 'Explorar site'
    },
    resumedMap: {
        title: 'Mapa Resumido',
        desc: 'Principais Informações'
    },
    birthChart: {
        title: 'Mapa astral',
        desc: 'Seu mapa completo'
    },
    horoscope: {
        title: 'Horóscopo',
        desc: 'Suas influências diárias',
        link: 'horoscopo-pessoal'
    },
    synastry: {
        title: 'Sinastrias',
        desc: 'Compatibilidade astral'
    },
    extraBirthChart: {
        title: 'Mapas Extras',
        desc: 'Mapas de outras pessoas'
    },
    tarot: {
        title: 'Tarot',
        desc: 'Faça uma consulta'
    },
    knowledge: {
        title: 'Conhecimento',
        desc: 'Aprenda sobre astrologia'
    },
    moonPhases: {
        title: 'Ciclo Lunar',
        desc: 'A Lua no momento'
    },
    lunarNodes: {
        title: 'Nodos Lunares',
        desc: 'Sua evolução pessoal'
    },
    journal: {
        title: 'Diário Pessoal',
        desc: 'Reflita sobre seu dia'
    },
    chest: {
        title: 'Guias Astrológicos',
        desc: 'Conteúdos Exclusivos'
    },
    biorhythm: {
        title: 'Biorritmo',
        desc: 'Seus ciclos pessoais'
    },
    calendar: {
        title: 'Calendário',
        desc: 'Eventos astrológicos'
    },
    chakrasGuide: {
        title: 'Guia de Chakras',
        desc: 'Equilíbrio da sua energia pessoal',
        link: 'chakras-guide'
    },
    careerMap: {
        title: 'Mapa Astral de Carreira',
        desc: 'Sua vocação e seu potencial'
    },
    guideOfTheYear: {
        title: 'Guia 2026',
        desc: 'Previsões e dicas personalizadas',
        accessibilityLabel: 'Acessar Guia do Ano 2026',
        imageAlt: 'Banner do Guia do Ano 2026 - Acesse agora'
    },
    orbia: {
        title: 'Assistente',
        desc: '(IA do Astrolink)'
    },
    loveMap: {
        title: 'Mapa do Amor',
        desc: 'Descubra seu jeito de amar'
    },
    personalitiesListing: {
        title: 'Mapas dos Famosos',
        desc: 'Tudo sobre seus maiores ídolos'
    }
};
